import {
  AnalyticsFilter,
  AnalyticsService,
  AuthorizationService,
  LoggingService,
} from "app/shared";
import { Subscription } from "rxjs";
import { UserAnalyticConfiguration } from "app/shared/model/charts/user-analytic-configurations.model";
import { ChartDefinition } from "./chartDefinitions.config";

export abstract class CommonAnalyticsLogic<TConfig> {
  protected analyticsService: AnalyticsService;
  protected authService: AuthorizationService;
  protected loggingService: LoggingService;
  protected subscriptions: Subscription[] = [];
  protected filterSettings: AnalyticsFilter = new AnalyticsFilter();
  protected showTitle: boolean = true;
  protected isLoading: boolean = true;
  protected hasData: boolean = false;



  /**
   * Assign type to config in the child class of specific chart.
   */
  protected config: TConfig | any | null = null;

  /**
   * Assign value from ChartDefinitions to chartDetails in the child class
   */
  protected chartDetails: ChartDefinition = (new this.configTypeConstructor())["chartDefinition"];

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    private configTypeConstructor: new () => TConfig
  ) {
    this.analyticsService = analyticsService;
    this.authService = authService;
    this.loggingService = loggingService;
  }

  protected abstract init(): void;

  protected cleanup(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Assign values to config data, by type.
   * @param data
   */
  protected assignConfigData(data?: UserAnalyticConfiguration): void {
    this.loggingService.log("CommonAnalyticsLogic - assignConfigData - before: ", data);
    this.config = data
      ? (Object.assign(new this.configTypeConstructor(), data.config) as TConfig)
      : new this.configTypeConstructor();

    this.loggingService.log("CommonAnalyticsLogic - assignConfigData - after: ", this.config);
  }

  protected getConfigType(): string {
    return this.chartDetails?.uniqueId || this.chartDetails?.title;
  }

  protected getConfigModel(settings: any): UserAnalyticConfiguration {
    return new UserAnalyticConfiguration({
      userid: this.authService.userId,
      configType: this.getConfigType(),
      config: settings,
    });
  }
}
